import { useState } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import apiClient from "@/api/client";

interface FeedbackButtonsProps {
  messageId: string;
}

export default function FeedbackButtons({ messageId }: FeedbackButtonsProps) {
  const [feedback, setFeedback] = useState<"helpful" | "unhelpful" | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleFeedback = async (type: "helpful" | "unhelpful") => {
    if (feedback === type || submitting) return;
    setSubmitting(true);
    try {
      await apiClient.post("/feedback", {
        message_id: messageId,
        rating: type,
      });
      setFeedback(type);
    } catch (err) {
      console.error("Failed to submit feedback:", err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
      <Typography variant="caption" sx={{ color: "#A99F8E", mr: 0.5 }}>
        这条回复有帮助吗？
      </Typography>
      <Tooltip title="有帮助">
        <IconButton
          size="small"
          onClick={() => handleFeedback("helpful")}
          disabled={submitting}
          sx={{
            color: feedback === "helpful" ? "#6B8E7B" : "#A99F8E",
            p: 0.5,
          }}
        >
          <ThumbUpOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="无帮助">
        <IconButton
          size="small"
          onClick={() => handleFeedback("unhelpful")}
          disabled={submitting}
          sx={{
            color: feedback === "unhelpful" ? "#B86B6B" : "#A99F8E",
            p: 0.5,
          }}
        >
          <ThumbDownOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
